var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 21.46c0 .83-.67 1.5-1.5 1.5h-13c-.83 0-1.5-.67-1.5-1.5v-11c0-.71.5-1.31 1.17-1.46h13.66A1.5 1.5 0 0120 10.46v11zM6 3.5A2.5 2.5 0 018.5 1h7A2.5 2.5 0 0118 3.5V8H6V3.5zm13 4.51V3.5C19 1.57 17.43 0 15.5 0h-7C6.57 0 5 1.57 5 3.5v4.51a2.5 2.5 0 00-2 2.45v11a2.5 2.5 0 002.5 2.5h13a2.5 2.5 0 002.5-2.5v-11a2.5 2.5 0 00-2-2.45z"
  })));
}
SvgLock.displayName = 'Lock';
export default SvgLock;